import styled from 'styled-components'

interface MessageStyleProps {
  featured: boolean
}

export const AuditoriumMessageStyle = styled.div<MessageStyleProps>`
  text-align: left;
  border-bottom: solid 1px #fff;
  background: ${(props) => (props.featured ? '#fff' : 'transparent')};
  padding: 6px 4px;
  position: ${(props) => (props.featured ? 'sticky' : 'relative')};
  ${(props) => props.featured && `top : 0; left: 0; right: 8px; margin: 0; z-index: 1;`};

  :last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  :first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .message {
    padding: 8px;
    margin: 0 6px;
    color: ${(props) => (props.featured ? '#FFF' : '#3c3c3c')};
    font-size: 13px;
    background: #fff;
    border-radius: 8px;
  }
  .sender {
    font-size: 10px;

    .name {
      margin-top: 3px;
      color: ${(props) => (props.featured ? '#FFF' : 'black')};
      text-transform: capitalize;
    }

    .timestamp {
      font-size: 0.8em;
      color: ${(props) => (props.featured ? '#FFF' : '#999999')};
    }
  }
  svg {
    height: 18px;
    width: 18px;
  }
  .profile {
    margin: 0 4px;
    padding: 8px;
    .avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .review-container {
    position: absolute;
    top: 6px;
    right: 5px;
    button {
      border: none;
      background: none;
    }
  }
`
